import React from 'react'
import { DrilldownQuery } from './drilldown-query'
import { DeleteAttackEventTagMutation } from '../delete-attack-event-tag-mutation'
import { DrilldownContentView } from './drilldown-content-view'

export function DrilldownContent({
  organizationID,
  eventUuid,
  layout
}: {
  readonly organizationID: string
  readonly eventUuid: string
  readonly layout: 'panel' | 'page'
}) {
  return (
    <DrilldownQuery organizationID={organizationID} attackEventID={eventUuid}>
      {({ loading, refetch, attackEvent }) => {
        return (
          <DeleteAttackEventTagMutation organizationID={organizationID}>
            {(deleteAttackEventTag) => {
              if (loading) {
                return 'Working...' // TODO TS-972
              }
              return (
                <DrilldownContentView
                  layout={layout}
                  onRemoveTag={async (tag) => {
                    await deleteAttackEventTag({
                      tag,
                      eventUuid
                    })
                    await refetch()
                  }}
                  organizationId={organizationID}
                  attackEvent={attackEvent}
                />
              )
            }}
          </DeleteAttackEventTagMutation>
        )
      }}
    </DrilldownQuery>
  )
}
